import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'components/common';
import { Icon } from 'components/common/icons';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalPortal
} from 'components/common/modal';

const TaskIsTaskDialog = connect((state) => ({
  messages: state.messages
}))(
  class TaskIsTaskDialog extends Component {
    state = {
      showModal: true
    };

    handleClick = (value) => {
      const { onChoice } = this.props;
      this.setState({ showModal: false });
      onChoice(value);
    };

    render() {
      const { showModal } = this.state;
      const { messages } = this.props;

      return (
        <ModalPortal>
          <Modal
            visible={showModal}
            stopPropagation={true}
            title={messages.tasksSetAsTask}
            width="narrow"
          >
            <ModalContent>
              {messages.tasksIsTask}
              <div
                aria-label={messages.tasksIsTaskTooltip}
                data-tooltip={messages.tasksIsTaskTooltip}
                style={{
                  display: 'inline-block',
                  marginLeft: 5
                }}
              >
                <Icon icon="question-circle" />
              </div>
            </ModalContent>
            <ModalFooter>
              <Button
                category="danger"
                onClick={() => this.handleClick(false)}
                style={{ minWidth: 100 }}
                text={messages.commonNo}
              />
              <Button
                category="success"
                onClick={() => this.handleClick(true)}
                style={{ minWidth: 100 }}
                text={messages.commonYes}
              />
            </ModalFooter>
          </Modal>
        </ModalPortal>
      );
    }
  }
);

export default TaskIsTaskDialog;
